import useSelector from "src/utils/useSelector";
import {
    getFailedMessages,
    getMessages,
    getSendingMessages,
    hasMessageCenterLoaded,
    hasMessages as hasMessagesSelector,
    isMessageCenterLoading,
} from "src/store/selectors/messages";
import { getMessagesRequest, postMessageRequest } from "src/store/actions/messages";
import { useDispatch } from "react-redux";
import React, { useCallback, useEffect, useState } from "react";
import usePolling from "src/utils/usePolling";

function useMessageCenter() {
    // Redux Dispatch
    const dispatch = useDispatch();

    // Redux State
    const uuid = useSelector((state) => state.deal.uuid!);
    const loading = useSelector(isMessageCenterLoading);
    const loaded = useSelector(hasMessageCenterLoaded);
    const hasMessages = useSelector(hasMessagesSelector);
    const messages = useSelector(getMessages);
    const sending = useSelector(getSendingMessages);
    const failed = useSelector(getFailedMessages);

    // Initial Load
    useEffect(() => {
        dispatch(getMessagesRequest(uuid));
    }, [uuid, dispatch]);

    // Polling
    usePolling(() => dispatch(getMessagesRequest(uuid)), 10000, loading);

    // Input State
    const [message, setMessage] = useState("");

    // Input Change Handler
    const change = useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => setMessage(e.target.value), []);

    // POST Message
    const send = useCallback(() => {
        if (!message.trim()) {
            setMessage("");
            return;
        }

        dispatch(postMessageRequest(message, uuid));
        setMessage("");
    }, [dispatch, message, uuid]);

    // Retry All Failed Messages
    const retry = useCallback(() => failed.map((value) => dispatch(postMessageRequest(value, uuid))), [
        dispatch,
        failed,
        uuid,
    ]);

    return {
        loaded,
        hasMessages,
        message,
        messages,
        sending,
        failed,
        change,
        send,
        retry,
    };
}

export default useMessageCenter;
